<template>
    <div>
        <PageHeader></PageHeader>
        <router-view tag="main" />
        <Player></Player>
    </div>
</template>

<script>
import PageHeader from "./components/pageHeader";
import Player from '@/components/Player';
export default {
    components:{ PageHeader,Player}
}
</script>

<style lang="scss" scoped>

</style>